import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { UserService } from 'src/app/services/user/user.service';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-footer-section',
  templateUrl: './footer-section.component.html',
  styleUrls: ['./footer-section.component.css'],
})
export class FooterSectionComponent implements OnInit, OnDestroy {
  accessToken: string | null = null;
  isServicesOpen: boolean = true;
  isCompanyOpen: boolean = false;
  isLocationOpen: boolean = false;
  isCompanyUser: boolean = false;
  currentUrl: string = '';

  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.currentUrl = this.router.url;
    this.accessToken = this.userService.getAcessToken();
    this.checkUserRole();

    // Track route changes
    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((e: any) => {
        this.currentUrl = e.urlAfterRedirects;
      });

    // Listen for localStorage changes (Login/Logout)
    window.addEventListener('storage', () => {
      this.accessToken = this.userService.getAcessToken();
      this.checkUserRole();
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  checkUserRole() {
    const userInfo = this.userService.getUserInfo();
    const roleRaw = userInfo?.role || localStorage.getItem('role');
    const roleName = typeof roleRaw === 'object' && roleRaw !== null
      ? roleRaw.name
      : roleRaw;
    this.isCompanyUser = roleName?.toUpperCase() === 'COMPANY';
  }

  /**
   * True when the footer should show company-mode links:
   * - logged-in company user, OR
   * - guest browsing company landing pages (/company-home, /job-post)
   */
  get isCompanyPage(): boolean {
    if (this.isCompanyUser) return true;
    if (this.currentUrl?.includes('type=company')) return true;
    
    const path = (this.currentUrl || '').split('?')[0].split('#')[0];
    return path === '/company-home' || path === '/job-post' || path === '/virtual-interview-company';
  }

  goToLogin() {
    if (!this.accessToken) {
      const targetType = this.isCompanyPage ? 'company' : 'user';
      this.router.navigate(['/login'], { queryParams: { type: targetType } });
    }
  }
}
